function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_55",
  "data-name": "Group 55",
  transform: "translate(8663.442 -7803.381)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_54",
  "data-name": "Group 54"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_157",
  "data-name": "Path 157",
  d: "M-8498.176,7861.99c-.955-26.152-26.752-43.9-52.071-36.892-23.886-35.024-79.779-20.548-81.688,21.948-44.906,12.142-36.308,78.454,10.986,78.454h111.786C-8471.424,7925.5-8463.3,7873.2-8498.176,7861.99Z",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_158",
  "data-name": "Path 158",
  d: "M-8533.465,7875.457a15.531,15.531,0,0,0-10.933-4.421,15.514,15.514,0,0,0-10.935,4.421l-4.535,4.36a.578.578,0,0,0,0,.829l2.82,2.777a.587.587,0,0,0,.814,0l4.507-4.376a10.424,10.424,0,0,1,7.313-2.952,10.427,10.427,0,0,1,7.314,2.952,9.891,9.891,0,0,1,3.008,7.124,9.827,9.827,0,0,1-3.008,7.081,10.433,10.433,0,0,1-7.314,2.95,10.431,10.431,0,0,1-7.313-2.95l-18.261-17.8a15.612,15.612,0,0,0-10.934-4.421,15.508,15.508,0,0,0-10.934,4.421,14.831,14.831,0,0,0-4.536,10.7,14.86,14.86,0,0,0,4.536,10.7,15.538,15.538,0,0,0,10.934,4.419,15.516,15.516,0,0,0,10.934-4.419l4.507-4.362a.578.578,0,0,0,0-.829l-2.82-2.747a.589.589,0,0,0-.815,0l-4.506,4.346a10.422,10.422,0,0,1-7.313,2.952,10.418,10.418,0,0,1-7.312-2.952,9.883,9.883,0,0,1-3.01-7.124,9.844,9.844,0,0,1,3.01-7.08,10.422,10.422,0,0,1,7.313-2.951,10.426,10.426,0,0,1,7.313,2.951l18.246,17.812a15.617,15.617,0,0,0,10.934,4.419,15.519,15.519,0,0,0,10.935-4.419,14.8,14.8,0,0,0,4.55-10.7,14.721,14.721,0,0,0-4.508-10.715Z",
  transform: "translate(-6.016 -5.699)",
  fill: "#fff"
}));

var SvgSageIcon4 = function SvgSageIcon4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189.507,
    height: 124.119,
    viewBox: "0 0 189.507 124.119",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSageIcon4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sageIcon4.6f094c34.svg";
export { ForwardRef as ReactComponent };